// src/Pages/Unauthorized.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/mainMenu.css";
import "../assets/css/addunit.css";

const Unauthorized = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate("/");
  };

  return (
    <div style={{}}>
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <div className="show-breadcrumb pt-3">
            <h5>Unauthorized</h5>
            <nav className="breadcrumb-nav" aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a
                    onClick={goBack}
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    className=""
                    href="/"
                  >
                    Go Home
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Unauthorized
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="text-center mt-5" style={{ padding: "20px" }}>
          <h1 className="display-4">403</h1>
          <p className="lead">
            You do not have permission to access this page.
          </p>
          <button
            type="button"
            className="btn-bg"
            onClick={goBack}
            style={{ height: "40px", width: "200px" }}
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
